const PLAYER_VERSION = '7.12.0'

export default PLAYER_VERSION
